import { Component, OnInit } from '@angular/core';

//declare var require: any;
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-version-check',
  template: `{{'{"Version":"' + version + '"}'}}`,
  styleUrls: ['./version-check.component.scss']
})
export class VersionCheckComponent implements OnInit {
  //version: string = require( '../../../package.json').version;

  version: string;

  constructor() { 
  }

  ngOnInit() {
    this.version = environment.version;
  }
}
